import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  handle: {
    cursor: "col-resize",
    
    right: -4,
    width: 2,
    // zIndex: 9999,
    background: theme.palette.text.primary+"9A",
    top: "calc(50% - 12px)",
    height: 24,
    transition: "opacity 0.3s ease-in-out",
  },
  handleFurther: {
    right: -6,
  }
}));

export default useStyle;